export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10376.c52863a9.jpg";